import styled, { css, keyframes } from "styled-components";

const seconds = keyframes`
    from {
        opacity: 1;
    } 
    to {
        opacity: 0;
    }
`;
export const BubbleTriangle = styled.div`
  position: absolute;
  width: 0;
  height: 0;
  top: 0px;
  z-index: 500;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 11px solid #c9900b;
  display: none;
  display: ${(props) => (props.isOwner ? "block" : "none")};

  ${(props) => css`
    animation: ${seconds} 10s forwards;
  `};
`;

export const DonorName = styled.div`
  position: absolute;
  white-space: nowrap;
  top: -30px;
  z-index: 500;
  padding: 4px;
  background-color: #c9900b;
  color: #ffffff;
  font-family: Rambla;
  display: ${(props) => (props.isOwner ? "block" : "none")};

  ${(props) => css`
    animation: ${seconds} 10s forwards;
  `};
`;

// width: 32px;
// height: 32px;

export const DonorNameWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: ${(props) => (props.width ? props.width + "px" : "32px")};
  height: ${(props) => (props.height ? props.height + "px" : "32px")};
  margin: 0px;
  background-color: ${(props) => `rgba(255, 255, 255, ${props.opacity})`};
  /* &:hover {
        & .donorName {
            display: ${(props) => (props.showDonor ? "block" : "none")};
        }   
    } */
  /* display: ${(props) => (props.showDonor ? "block" : "none")}; */
  &:active {
    & .donorName {
      display: ${(props) => (props.showDonor ? "block" : "none")};
    }
  }
`;

export const OverlayOld = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10;
`;
export const Overlay = styled.div`
  // position: absolute;
  // width: 100%;
  height: 100%;
  // background-color: rgba(0, 0, 0, 0.5);
  padding: 10px 10px;
  //z-index: 10;
`;

export const ModalApp = styled.div`
  // position: absolute;

  // left: 50%;
  // top: 50vh;
  background-color: #fff;
  border-radius: 10px;
  /* display: initial; */
  /* width: fit-content; */
  padding: 10px 10px;
  // transform: translate(-50%);
`;

export const ModalOld = styled.div`
  position: absolute;

  left: 50%;
  top: 50vh;
  background-color: #fff;
  border-radius: 10px;
  /* display: initial; */
  width: fit-content;
  padding: 10px 10px;
  transform: translate(-50%);
`;

/*
position: sticky;
  left: 50vw;
  top: 50vh;


*/
